import { MetaData } from 'models/general';
import {
  getLaminasApiData, getTaxReportsApiData, getMockData, serializeTaxReportBody,
} from 'services/api';

export interface TableDataRes<T, U> {
  data: T[];
  meta: MetaData;
  info: U | undefined;
  cacheDateTime: string | null;
}

export enum SortDirection {
  DESC = 'desc',
  ASC = 'asc',
}

export enum TableBaseApiKind {
  LAMINAS = 'laminas',
  TAX_REPORTS = 'taxReports',
}

export interface SortDescription {
  sortingField: string;
  sortingDirection: SortDirection;
}

export const getLaminasTableData = <T, U>(
  requestUriProp: string,
  page: number,
  limit: number,
  sort: SortDescription | undefined,
  filters: string,
  signal: AbortSignal,
  mockDataProp?: boolean | undefined,
): Promise<TableDataRes<T, U>> => {
  const connector = requestUriProp.includes('?') ? '&' : '?';

  const sortParameters = sort
    ? `&sort[field]=${sort.sortingField}&sort[direction]=${sort.sortingDirection}`
    : '';
  const filterParameters = filters ? `&${filters}` : '';

  if (mockDataProp) {
    return getMockData<TableDataRes<T, U>>(
      `${requestUriProp}${connector}_page=${page}&_limit=${limit}`,
    );
  }

  return getLaminasApiData<TableDataRes<T, U>>(
    `${requestUriProp}${connector}page=${page}&limit=${limit}${sortParameters}${filterParameters}`,
    signal,
  );
};

export const getTaxReportsTableData = <T, U>(
  requestUriProp: string,
  page: number,
  limit: number,
  sort: SortDescription | undefined,
  filters: string,
  userId: number,
  signal: AbortSignal,
  mockDataProp?: boolean | undefined,
): Promise<TableDataRes<T, U>> => {
  const connector = requestUriProp.includes('?') ? '&' : '?';
  const sortParameters = sort
    ? `, "sortField": "${sort.sortingField}", "sortDirection": "${sort.sortingDirection}"`
    : '';
  const filterParameters = filters ? `, ${filters}` : '';

  const queryString: string = serializeTaxReportBody({
    method: 'GET',
    path: '/reports/tax/validation',
    body: `{"user_id": ${userId}, "limit": ${limit}, "page": ${page}${sortParameters}${filterParameters}}`,
    header: 'Accept: application/json',
  });

  if (mockDataProp) {
    return getMockData<TableDataRes<T, U>>(
      `${requestUriProp}${connector}${queryString}`,
    );
  }

  return getTaxReportsApiData<TableDataRes<T, U>>(
    `${requestUriProp}${connector}${queryString}`,
    signal,
  );
};
